// @flow

import type { OpenedIncomingPayment } from '@tectonics/prs/incoming-payment';
import type { OneClickCard } from '@tectonics/prs/one-click-card/types';

export function getOneClickCardOrCry(incomingPayment: OpenedIncomingPayment): OneClickCard {
  const oneClickCard = getOneClickCard(incomingPayment);
  if (!oneClickCard) {
    throw new Error('OneClickCardInfo - One Click Card is empty');
  }

  return oneClickCard;
}

export function getOneClickCard(incomingPayment: OpenedIncomingPayment): ?OneClickCard {
  const [oneClickCard] = incomingPayment.one_click || [];
  return oneClickCard;
}
